import { motion } from "framer-motion";
import Seo from "@/components/Seo";

const sections = [
  {
    title: "Éditeur du site",
    body: (
      <>
        <p>Le présent site est édité par :</p>
        <ul className="mt-3 space-y-1.5">
          <li><strong className="text-white">LMB SERVICES</strong></li>
          <li>EURL au capital de 1 000 €</li>
          <li>Siège social : 225 avenue des Marronniers, 38300 Bourgoin-Jallieu, France</li>
          <li>SIREN : 103 616 124</li>
          <li>RCS : Vienne</li>
          <li>TVA intracommunautaire : FR50103616124</li>
          <li>Téléphone : <a href="tel:+33745709881" className="text-[#C9A962] hover:underline">07 45 70 98 81</a></li>
          <li>E-mail : <a href="mailto:pixora.photobooth38@gmail.com" className="text-[#C9A962] hover:underline">pixora.photobooth38@gmail.com</a></li>
        </ul>
        <p className="mt-4">Le directeur de la publication est le gérant de LMB SERVICES.</p>
      </>
    ),
  },
  {
    title: "Hébergement",
    body: (
      <>
        <p>Le site est hébergé par le prestataire technique utilisé par la plateforme Emergent.</p>
        <p className="mt-3">Les informations relatives à l'hébergeur peuvent être communiquées sur simple demande conformément aux dispositions légales.</p>
      </>
    ),
  },
  {
    title: "Propriété intellectuelle",
    body: (
      <>
        <p>L'ensemble des éléments présents sur ce site (textes, photographies, vidéos, logos, illustrations, éléments graphiques, identité visuelle, marques et contenus) est protégé par les dispositions du Code de la propriété intellectuelle.</p>
        <p className="mt-3">Toute reproduction, représentation, diffusion, modification ou exploitation, totale ou partielle, sans autorisation écrite préalable de LMB SERVICES est strictement interdite.</p>
      </>
    ),
  },
  {
    title: "Responsabilité",
    body: (
      <>
        <p>Les informations publiées sur ce site sont fournies à titre indicatif. LMB SERVICES s'efforce d'assurer leur exactitude et leur mise à jour régulière, sans pouvoir garantir l'absence totale d'erreurs ou d'omissions.</p>
        <p className="mt-3">LMB SERVICES ne pourra être tenue responsable des dommages directs ou indirects résultant de l'utilisation du présent site.</p>
      </>
    ),
  },
  {
    title: "Liens hypertextes",
    body: <p>Le site peut contenir des liens vers des sites internet tiers. LMB SERVICES ne peut être tenue responsable du contenu ou du fonctionnement de ces sites externes.</p>,
  },
  {
    title: "Droit applicable",
    body: (
      <>
        <p>Le présent site est soumis au droit français.</p>
        <p className="mt-3">Tout litige relatif à son utilisation relève de la compétence des juridictions françaises.</p>
      </>
    ),
  },
];

export default function MentionsLegales() {
  return (
    <div className="pt-24 md:pt-32 lg:pt-36 pb-24 bokeh-strong min-h-screen" data-testid="mentions-legales-page">
      <Seo
        title="Mentions légales | Pixora Photobooth"
        description="Mentions légales du site Pixora Photobooth."
        path="/mentions-legales"
        noindex
      />
      <div className="max-w-4xl mx-auto px-4 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="mb-14 text-center"
        >
          <p className="text-xs tracking-[0.3em] text-[#C9A962] mb-4">INFORMATIONS LÉGALES</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white">
            Mentions <span className="text-[#C9A962]">Légales</span>
          </h1>
        </motion.div>

        <div className="space-y-10">
          {sections.map((s, i) => (
            <motion.section
              key={s.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: i * 0.05 }}
              className="p-6 sm:p-8 rounded-2xl bg-black/40 border border-[#C9A962]/20 backdrop-blur-sm"
              data-testid={`legal-section-${i}`}
            >
              <h2 className="text-xl sm:text-2xl font-semibold text-[#C9A962] mb-4">{s.title}</h2>
              <div className="text-[#D8CCA8] text-[15px] leading-relaxed">{s.body}</div>
            </motion.section>
          ))}
        </div>
      </div>
    </div>
  );
}
